<template>
  <form
    name="SBPaymentCall"
    :action="postUrl"
    method="POST"
    accept-charset="shift_jis"
  >
    <noscript>
      <h2>処理を続けます。</h2>
      <p>ボタンをクリックしてください。</p>
      <input type="submit" value="OK" />
    </noscript>
    <input
      v-for="(value, key) in formObject"
      :key="key"
      :name="key"
      :value="value"
      type="hidden"
    />
  </form>
</template>
<script>
export default {
  props: {
    postUrl: {
      type: String,
      required: true
    },
    formObject: {
      type: Object,
      required: true
    }
  },
  mounted() {
    document.SBPaymentCall.submit()
  }
}
</script>
